import { get, post, patch, deleteMethod, createApiUrl } from '../utils/request';
import { logger } from '../utils/logger';
const endpoint = createApiUrl('/souls');
// 匿名ログイン
export async function createAnonymousSoul(language, turnstileToken) {
    // ブラウザ環境ではTurnstileトークンが推奨される（必須ではない）
    if (typeof window !== 'undefined' && !turnstileToken) {
        logger.warn('Turnstile token not provided. Bot protection may be bypassed.');
    }
    // ワンタイムトークンを取得（Turnstileトークンがあれば一緒に送信）
    const tokenPayload = turnstileToken ? { turnstileToken } : undefined;
    const { token } = await (tokenPayload
        ? post()(createApiUrl('/token'), tokenPayload)
        : get()(createApiUrl('/token')));
    // ワンタイムトークンでsoul作成
    return await post(token)(endpoint, { language });
}
// セッションログイン
export async function retrieveSoul(soulId, sessionToken) {
    return await get(sessionToken)(`${endpoint}/${soulId}`);
}
// OAuthログイン
export async function retrieveSoulByOAuth(oauthResult) {
    const searchQuery = `?provider=${oauthResult.provider}&providerId=${encodeURIComponent(oauthResult.providerId)}`;
    return await get()(`${endpoint}${searchQuery}`);
}
// OAuth紐づけ
export async function engraveSoul(soulId, sessionToken, oauthResult) {
    return await post(sessionToken)(`${endpoint}/${soulId}/oauths`, oauthResult);
}
// OAuth連携解除
export async function unbindSoul(soulId, sessionToken, provider) {
    return await deleteMethod(sessionToken)(`${endpoint}/${soulId}/oauths/${provider}`);
}
